(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Bundle-Deal"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.bundle-deal-section');
  if (!section) return;

  var navItems = section.querySelectorAll('.bd-nav-item');
  var panels = section.querySelectorAll('.bd-tab-panel');

  navItems.forEach(function(item) {
    item.addEventListener('click', function() {
      var index = this.getAttribute('data-tab-index');

      navItems.forEach(function(el) { el.classList.remove('active'); });
      panels.forEach(function(el) { el.classList.remove('active'); });

      this.classList.add('active');
      var targetPanel = section.querySelector('.bd-tab-panel[data-panel-index="' + index + '"]');
      if (targetPanel) targetPanel.classList.add('active');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;

      if (productRecommendationsSection.dataset.excludedProducts) {
        var excludedIds = productRecommendationsSection.dataset.excludedProducts.split(',');
        var productBlocks = container.querySelectorAll('.product-block');

        productBlocks.forEach(function(block) {
          var productId = block.getAttribute('data-product-id');
          if (productId && excludedIds.includes(productId)) {
            block.remove();
          }
        });
        var productBlocks = container.querySelectorAll('.product-block');

        var gridSetting = parseInt(productRecommendationsSection.dataset.grid) || 4;
        if (productBlocks.length > gridSetting) {
          for (var i = gridSetting; i < productBlocks.length; i++) {
            if (productBlocks[i]) {
              productBlocks[i].remove();
            }
          }
        }

        if (container.querySelectorAll('.product-block').length === 0) {
          productRecommendationsSection.style.display = 'none';
          return;
        }
      }

      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
